import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport } from "vue";
const _hoisted_1 = { class: "h-100 p-3 p-md-4 py-5" };
const _hoisted_2 = {
    key: 0,
    class: "d-flex justify-content-center"
};
const _hoisted_3 = { class: "ms-2 text-white" };
const _hoisted_4 = { class: "row" };
const _hoisted_5 = { class: "w-100" };
const _hoisted_6 = { class: "w-100 mt-3 mb-5" };
const _hoisted_7 = {
    class: "nav nav-pills flex-column w-100",
    id: "configurator-menu",
    role: "tablist"
};
const _hoisted_8 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_9 = {
    key: 0,
    class: "ms-3"
};
const _hoisted_10 = {
    key: 0,
    class: "nav-item"
};
const _hoisted_11 = {
    class: "nav-link w-100 text-start disabled",
    id: "pills-3-option",
    type: "button",
    role: "tab"
};
const _hoisted_12 = { class: "small text-primary fw-bold ms-3" };
const _hoisted_13 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_14 = ["id", "data-bs-target"];
const _hoisted_15 = {
    key: 2,
    class: "nav-item",
    role: "presentation"
};
const _hoisted_16 = {
    key: 0,
    class: "ms-3"
};
const _hoisted_17 = {
    key: 3,
    class: "nav-item",
    role: "presentation"
};
const _hoisted_18 = {
    key: 0,
    class: "small text-primary fw-bold ms-3"
};
const _hoisted_19 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_20 = ["disabled"];
const _hoisted_21 = {
    key: 0,
    class: "ms-3"
};
const _hoisted_22 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_23 = ["disabled"];
const _hoisted_24 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_25 = ["disabled"];
const _hoisted_26 = { class: "border-top mt-3 pt-3" };
const _hoisted_27 = { class: "mb-3" };
const _hoisted_28 = {
    key: 0,
    class: "w-100 btn btn-sm btn-light d-inline-flex align-items-center mb-3",
    "data-bs-toggle": "modal",
    "data-bs-target": "#saveConfigurationInfo"
};
const _hoisted_29 = { class: "ms-2" };
const _hoisted_30 = { class: "d-flex justify-content-between flex-wrap" };
const _hoisted_31 = ["href", "target"];
const _hoisted_32 = { class: "ms-2" };
const _hoisted_33 = ["href", "target"];
const _hoisted_34 = { class: "ms-2" };
const _hoisted_35 = {
    key: 0,
    class: "mt-5 small"
};
const _hoisted_36 = { class: "w-100 h-100" };
const _hoisted_37 = {
    class: "tab-content h-100 p-0 p-md-3 pt-4",
    id: "configurator-menu-tabContent"
};
const _hoisted_38 = ["id"];
const _hoisted_39 = {
    key: 1,
    class: "tab-pane fade h-100",
    id: "pills-4",
    role: "tabpanel",
    "aria-labelledby": "pills-4-option",
    tabindex: "0"
};
const _hoisted_40 = {
    key: 2,
    class: "tab-pane fade h-100",
    id: "pills-5",
    role: "tabpanel",
    "aria-labelledby": "pills-5-option",
    tabindex: "0"
};
const _hoisted_41 = {
    key: 3,
    class: "tab-pane fade h-100",
    id: "pills-6",
    role: "tabpanel",
    "aria-labelledby": "pills-6-option",
    tabindex: "0"
};
const _hoisted_42 = {
    class: "tab-pane fade h-100 position-relative",
    id: "pills-8",
    role: "tabpanel",
    "aria-labelledby": "pills-8-option",
    tabindex: "0"
};
const _hoisted_43 = {
    key: 0,
    class: "modal fade",
    id: "saveConfigurationInfo"
};
const _hoisted_44 = { class: "modal-dialog modal-dialog-centered modal-xl" };
const _hoisted_45 = { class: "modal-content bg-white" };
const _hoisted_46 = { class: "modal-header border-0 px-5 pt-5" };
const _hoisted_47 = { class: "modal-title text-center w-100" };
const _hoisted_48 = { class: "modal-body text-center" };
const _hoisted_49 = { class: "fw-bold" };
const _hoisted_50 = ["href"];
import { cssStyleSheetLoader } from '@/Configurator/Composables/cssStyleSheetLoader';
import BottleConfiguration from '@/Configurator/Components/BottleConfiguration.vue';
import BottleSelection from '@/Configurator/Components/BottleSelection.vue';
import LidConfiguration from '@/Configurator/Components/LidConfiguration.vue';
import LidSelection from '@/Configurator/Components/LidSelection.vue';
import Overview from '@/Configurator/Components/Overview.vue';
import PackageSelection from '@/Configurator/Components/PackageSelection.vue';
import ConfigurationPriceCalculator from '@/Configurator/Shared/ConfigurationPriceCalculator.vue';
import { usePage } from '@inertiajs/vue3';
import { nextTick, onMounted, ref } from 'vue';
import ConfiguratorLayout from '@/Configurator/Layouts/ConfiguratorLayout.vue';
import { observeDOMChanges, sendHeight } from '../Composables/iframeHeightCalculator';
import Swal from 'sweetalert2';
import { Tab } from 'bootstrap';
import { useI18n } from 'vue-i18n';
import AiPreview from '../Components/AiPreview.vue';
import { loadTenantConfigs } from '../Composables/standardFunctions';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Configurator',
    props: {
        configurationId: String,
        tenantId: String,
        externalConfigurationId: String,
        cssFileUrl: {
            type: String,
            default: null
        },
        sessionId: String,
        configuratorUrl: {
            type: String
        },
        configurationUrl: {
            type: String
        },
        hasOrder: {
            type: Boolean,
            default: false
        },
        showFilters: Boolean,
        publicFilters: {
            type: Array,
            default: () => []
        }
    },
    setup(__props) {
        const { t } = useI18n();
        const props = __props;
        let { loadCssStyleSheet } = cssStyleSheetLoader();
        const standardProductType = ref(null);
        const user = usePage().props.auth.user;
        const configurationKey = ref('');
        const lidSelectionConfigurationKey = ref(null);
        const lidConfigurationKey = ref(null);
        const packageConfigurationKey = ref(null);
        const previewConfigurationKey = ref('');
        const priceCalculatorKey = ref('');
        const aiPreviewConfigurationKey = ref('');
        //products amount
        const productsAmount = ref(1000);
        //Bottle configuration
        const selectedBottle = ref(null);
        //Lid configuration
        const selectedLid = ref(null);
        const selectedLidVariant = ref(null);
        const availableLids = ref(false);
        //Package configuration
        const selectedPackage = ref(null);
        const isConfigurationLoaded = ref(false);
        const hasBottlePreselection = ref(false); //if true, start with the first configuration step
        const isLoadingConfiguration = ref(false);
        const bottleSelectionInitiated = ref(false);
        const blockedConfigurationSteps = ref({});
        onMounted(async () => {
            if (props.cssFileUrl) {
                loadCssStyleSheet(props.cssFileUrl);
            }
            standardProductType.value = await loadTenantConfigs('standard_product_type');
            if (props.hasOrder) {
                openedNav.value = false;
                renderConfiguration();
            }
            configurationKey.value = generateKey();
            priceCalculatorKey.value = generateKey();
            sendHeight();
            observeDOMChanges();
            sessionStorage.setItem('startConfigurationTimestamp', String(Date.now()));
            checkForLoadedConfiguration();
            showMobileInfoOnSmallScreens();
        });
        function checkForLoadedConfiguration() {
            const flash = usePage().props.flash;
            if (flash.isLoadedConfiguration) {
                renderConfiguration();
            }
        }
        function renderConfiguration() {
            isConfigurationLoaded.value = true;
            setTimeout(() => {
                updatePreviewConfigurationKey();
                setTimeout(() => {
                    updatePreviewConfigurationKey();
                    isLoadingConfiguration.value = false;
                }, 1000);
            }, 1000);
            Swal.fire({
                title: t('Konfiguration wird geladen ...'),
                icon: "info",
                timerProgressBar: true,
                showConfirmButton: false,
                background: '#fff',
                backdrop: '#fff',
                timer: 3500
            });
        }
        function updateProductsAmount(amount) {
            productsAmount.value = amount;
        }
        function updateBottleSelection(bottle) {
            //if bottle selection is older than 10 seconds, re-render the configuration
            if (bottle.selectionUpdatedAt) {
                const updatedAtTimestamp = new Date(bottle.selectionUpdatedAt).getTime();
                if ((Date.now() - updatedAtTimestamp) > 5000) {
                    isLoadingConfiguration.value = true;
                    renderConfiguration();
                }
                else {
                    hasBottlePreselection.value = true;
                }
            }
            else {
                bottleSelectionInitiated.value = true;
            }
            configurationKey.value = generateKey();
            lidSelectionConfigurationKey.value = null;
            lidConfigurationKey.value = null;
            packageConfigurationKey.value = null;
            // previewConfigurationKey.value = generateKey();
            selectedBottle.value = bottle;
            selectedLid.value = null;
            selectedPackage.value = null;
            availableLids.value = true;
            //Prevent multiple updates when loading a configuration
            if (!isLoadingConfiguration.value) {
                updatePreviewConfigurationKey();
            }
            if (bottleSelectionInitiated.value) {
                nextTick(() => {
                    const tabEl = document.querySelector('#pills-3-option-0');
                    const tab = new Tab(tabEl);
                    tab.show();
                });
            }
            bottleSelectionInitiated.value = true;
        }
        function updateBottleConfiguration() {
            // previewConfigurationKey.value = generateKey();
        }
        function updateLidSelection(lid, lidVariant) {
            lidConfigurationKey.value = null;
            // previewConfigurationKey.value = generateKey();
            selectedLid.value = lid;
            selectedLidVariant.value = lidVariant;
            // priceCalculatorKey.value = generateKey();
        }
        function updateLidConfiguration() {
            // previewConfigurationKey.value = generateKey();
        }
        function updatePackageSelection(packageRecord) {
            selectedPackage.value = packageRecord;
            // priceCalculatorKey.value = generateKey();
        }
        function generateKey() {
            return Math.random().toString(36).substring(7);
        }
        function accessLidSelection() {
            if (lidSelectionConfigurationKey.value == null) {
                lidSelectionConfigurationKey.value = generateKey();
            }
        }
        function accessLidConfiguration() {
            if (lidConfigurationKey.value == null) {
                lidConfigurationKey.value = generateKey();
            }
        }
        function accessPackages() {
            if (packageConfigurationKey.value == null) {
                packageConfigurationKey.value = generateKey();
            }
        }
        function updatePreviewConfigurationKey() {
            accessLidSelection();
            accessLidConfiguration();
            accessPackages();
            previewConfigurationKey.value = generateKey();
        }
        function updateAiPreviewConfigurationKey() {
            accessLidSelection();
            accessLidConfiguration();
            accessPackages();
            aiPreviewConfigurationKey.value = generateKey();
        }
        const openedNav = ref(true);
        function closeNav() {
            openedNav.value = false;
        }
        function openNav() {
            openedNav.value = true;
        }
        function selectConfigurationStep(tabButtonId) {
            const tabTriggerEl = document.querySelector(tabButtonId);
            if (tabTriggerEl) {
                const tab = new Tab(tabTriggerEl);
                tab.show(); // Zeigt das Tab an
            }
        }
        function showMobileInfoOnSmallScreens() {
            if (window.innerWidth < 768) {
                Swal.fire({
                    position: "top",
                    title: t('Hinweis'),
                    text: t('Für das beste Benutzererlebnis und besten Ergebnisse empfehlen wir Ihnen den Konfigurator mindestens auf einem Tablet oder Notebook zu verwenden. Bitte nutzen Sie einen Desktop-Browser für die volle Funktionalität.'),
                    icon: 'info',
                    confirmButtonText: t('OK'),
                    background: '#fff',
                    backdrop: '#fff',
                    confirmButtonColor: "#528399",
                });
            }
        }
        function blockFurtherConfiguration(id, blocked) {
            if (blocked) {
                blockedConfigurationSteps.value[id] = true;
            }
            else {
                delete blockedConfigurationSteps.value[id];
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(ConfiguratorLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                            (!props.hasOrder)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    (!openedNav.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "btn btn-primary d-flex align-items-center m-1",
                                            onClick: _cache[0] || (_cache[0] = ($event) => (openNav()))
                                        }, [
                                            _cache[10] || (_cache[10] = _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-list text-white",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", {
                                                    "fill-rule": "evenodd",
                                                    d: "M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
                                                })
                                            ], -1)),
                                            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('Menü/Optionen')), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", {
                                    class: _normalizeClass(["col-12 col-lg-3 col-xxl-2 d-flex align-items-top border-end", { 'd-none': !openedNav.value }])
                                }, [
                                    _createElementVNode("div", _hoisted_5, [
                                        (openedNav.value)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 0,
                                                class: "btn btn-secondary d-flex align-items-center",
                                                onClick: _cache[1] || (_cache[1] = ($event) => (closeNav()))
                                            }, [...(_cache[11] || (_cache[11] = [
                                                    _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "16",
                                                        fill: "currentColor",
                                                        class: "bi bi-x-lg text-white",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" })
                                                    ], -1)
                                                ]))]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("ul", _hoisted_7, [
                                                _createElementVNode("li", _hoisted_8, [
                                                    _createElementVNode("button", {
                                                        class: _normalizeClass(["nav-link w-100 text-start d-inline-flex align-items-center", { 'active': !isConfigurationLoaded.value && !hasBottlePreselection.value }]),
                                                        id: "pills-1-option",
                                                        "data-bs-toggle": "pill",
                                                        "data-bs-target": "#pills-1",
                                                        type: "button",
                                                        role: "tab",
                                                        "aria-controls": "pills-1",
                                                        "aria-selected": "true"
                                                    }, [
                                                        _createTextVNode(_toDisplayString(standardProductType.value == 'glass' ? _unref(t)('Glas-Auswahl') : _unref(t)('Flaschen-Auswahl')) + " ", 1),
                                                        (selectedBottle.value)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_9, [...(_cache[12] || (_cache[12] = [
                                                                    _createElementVNode("svg", {
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        height: "20",
                                                                        fill: "currentColor",
                                                                        class: "bi bi-check2-circle",
                                                                        viewBox: "0 0 16 16"
                                                                    }, [
                                                                        _createElementVNode("path", { d: "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" }),
                                                                        _createElementVNode("path", { d: "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" })
                                                                    ], -1)
                                                                ]))]))
                                                            : _createCommentVNode("", true)
                                                    ], 2)
                                                ]),
                                                (selectedBottle.value == null)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                                                        _createElementVNode("button", _hoisted_11, _toDisplayString(standardProductType.value == 'glass' ? _unref(t)('Glas-Konfiguration') : _unref(t)('Flaschen-Konfiguration')), 1),
                                                        _createElementVNode("div", _hoisted_12, _toDisplayString(standardProductType.value == 'glass' ? _unref(t)('Bitte Glas zuerst wählen') : _unref(t)('Bitte Flasche zuerst wählen')), 1)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (selectedBottle.value)
                                                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(selectedBottle.value.printAreas, (printArea, index) => {
                                                        return (_openBlock(), _createElementBlock("li", _hoisted_13, [
                                                            _createElementVNode("button", {
                                                                class: _normalizeClass(["nav-link w-100 text-start", { 'active': !isConfigurationLoaded.value && hasBottlePreselection.value }]),
                                                                id: 'pills-3-option-' + index,
                                                                "data-bs-toggle": "pill",
                                                                "data-bs-target": '#pills-3-' + index,
                                                                type: "button",
                                                                role: "tab",
                                                                "aria-controls": "pills-3",
                                                                "aria-selected": "true",
                                                                onClick: _cache[2] || (_cache[2] = ($event) => (_unref(sendHeight)()))
                                                            }, _toDisplayString(standardProductType.value == 'glass' ? _unref(t)('Glas-Konfiguration') : _unref(t)('Flaschen-Konfiguration')) + " " + _toDisplayString(selectedBottle.value.printAreas.length > 1 ?
                                                                ' - ' + printArea.name : ''), 11, _hoisted_14)
                                                        ]));
                                                    }), 256))
                                                    : _createCommentVNode("", true),
                                                (availableLids.value)
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                                                        _createElementVNode("button", {
                                                            class: "nav-link w-100 text-start d-inline-flex align-items-center",
                                                            id: "pills-4-option",
                                                            "data-bs-toggle": "pill",
                                                            "data-bs-target": "#pills-4",
                                                            type: "button",
                                                            role: "tab",
                                                            "aria-controls": "pills-4",
                                                            "aria-selected": "true",
                                                            onClick: _cache[3] || (_cache[3] = ($event) => (accessLidSelection()))
                                                        }, [
                                                            _createTextVNode(_toDisplayString(_unref(t)('Verschluss-Auswahl')) + " ", 1),
                                                            (selectedLid.value && selectedLidVariant.value)
                                                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, [...(_cache[13] || (_cache[13] = [
                                                                        _createElementVNode("svg", {
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            height: "20",
                                                                            fill: "currentColor",
                                                                            class: "bi bi-check2-circle",
                                                                            viewBox: "0 0 16 16"
                                                                        }, [
                                                                            _createElementVNode("path", { d: "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" }),
                                                                            _createElementVNode("path", { d: "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" })
                                                                        ], -1)
                                                                    ]))]))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                (availableLids.value && (selectedLid.value == null || !selectedLid.value.printNotPossible))
                                                    ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                                                        _createElementVNode("button", {
                                                            class: _normalizeClass(["nav-link w-100 text-start", { disabled: selectedLid.value == null || selectedLidVariant.value == null }]),
                                                            id: "pills-5-option",
                                                            "data-bs-toggle": "pill",
                                                            "data-bs-target": "#pills-5",
                                                            type: "button",
                                                            role: "tab",
                                                            "aria-controls": "pills-5",
                                                            "aria-selected": "true",
                                                            onClick: _cache[4] || (_cache[4] = ($event) => (accessLidConfiguration()))
                                                        }, _toDisplayString(_unref(t)('Verschluss-Konfiguration')), 3),
                                                        (selectedLid.value == null || selectedLidVariant.value == null)
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_unref(t)('Bitte Verschluss zuerst wählen')), 1))
                                                            : _createCommentVNode("", true)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("li", _hoisted_19, [
                                                    _createElementVNode("button", {
                                                        disabled: selectedBottle.value == null,
                                                        class: "nav-link w-100 text-start d-inline-flex align-items-center",
                                                        id: "pills-6-option",
                                                        "data-bs-toggle": "pill",
                                                        "data-bs-target": "#pills-6",
                                                        type: "button",
                                                        role: "tab",
                                                        "aria-controls": "pills-6",
                                                        "aria-selected": "true",
                                                        onClick: _cache[5] || (_cache[5] = ($event) => (accessPackages()))
                                                    }, [
                                                        _createTextVNode(_toDisplayString(_unref(t)('Verpackung')) + " ", 1),
                                                        (selectedPackage.value)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, [...(_cache[14] || (_cache[14] = [
                                                                    _createElementVNode("svg", {
                                                                        xmlns: "http://www.w3.org/2000/svg",
                                                                        height: "20",
                                                                        fill: "currentColor",
                                                                        class: "bi bi-check2-circle",
                                                                        viewBox: "0 0 16 16"
                                                                    }, [
                                                                        _createElementVNode("path", { d: "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" }),
                                                                        _createElementVNode("path", { d: "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" })
                                                                    ], -1)
                                                                ]))]))
                                                            : _createCommentVNode("", true)
                                                    ], 8, _hoisted_20)
                                                ]),
                                                _createElementVNode("li", _hoisted_22, [
                                                    _createElementVNode("button", {
                                                        disabled: selectedBottle.value == null,
                                                        class: "nav-link w-100 text-start",
                                                        id: "pills-8-option",
                                                        "data-bs-toggle": "pill",
                                                        "data-bs-target": "#pills-8",
                                                        type: "button",
                                                        role: "tab",
                                                        "aria-controls": "pills-8",
                                                        "aria-selected": "true",
                                                        onClick: _cache[6] || (_cache[6] = ($event) => (updateAiPreviewConfigurationKey()))
                                                    }, _toDisplayString(_unref(t)('Vorschau')), 9, _hoisted_23)
                                                ]),
                                                _createElementVNode("li", _hoisted_24, [
                                                    _createElementVNode("button", {
                                                        disabled: selectedBottle.value == null,
                                                        class: _normalizeClass(["nav-link w-100 text-start fw-bold", { 'active': isConfigurationLoaded.value }]),
                                                        id: "pills-7-option",
                                                        "data-bs-toggle": "pill",
                                                        "data-bs-target": "#pills-7",
                                                        type: "button",
                                                        role: "tab",
                                                        "aria-controls": "pills-7",
                                                        "aria-selected": "true",
                                                        onClick: _cache[7] || (_cache[7] = ($event) => (updatePreviewConfigurationKey()))
                                                    }, _toDisplayString(_unref(t)('Übersicht')), 11, _hoisted_25)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_26, [
                                                _createElementVNode("div", _hoisted_27, [
                                                    (_openBlock(), _createBlock(ConfigurationPriceCalculator, {
                                                        configurationId: __props.configurationId,
                                                        tenantId: __props.tenantId,
                                                        minProductsAmount: selectedBottle.value ? selectedBottle.value.minOrderAmount : 1,
                                                        maxProductsAmount: selectedBottle.value ? selectedBottle.value.maxOrderAmount : 1,
                                                        productsAmountSteps: selectedBottle.value ? selectedBottle.value.productsAmountSteps : 1,
                                                        onUpdate: updateProductsAmount,
                                                        key: priceCalculatorKey.value
                                                    }, null, 8, ["configurationId", "tenantId", "minProductsAmount", "maxProductsAmount", "productsAmountSteps"]))
                                                ]),
                                                (props.externalConfigurationId)
                                                    ? (_openBlock(), _createElementBlock("button", _hoisted_28, [
                                                        _cache[15] || (_cache[15] = _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "16",
                                                            height: "16",
                                                            fill: "currentColor",
                                                            class: "bi bi-floppy",
                                                            viewBox: "0 0 16 16"
                                                        }, [
                                                            _createElementVNode("path", { d: "M11 2H9v3h2z" }),
                                                            _createElementVNode("path", { d: "M1.5 0h11.586a1.5 1.5 0 0 1 1.06.44l1.415 1.414A1.5 1.5 0 0 1 16 2.914V14.5a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 14.5v-13A1.5 1.5 0 0 1 1.5 0M1 1.5v13a.5.5 0 0 0 .5.5H2v-4.5A1.5 1.5 0 0 1 3.5 9h9a1.5 1.5 0 0 1 1.5 1.5V15h.5a.5.5 0 0 0 .5-.5V2.914a.5.5 0 0 0-.146-.353l-1.415-1.415A.5.5 0 0 0 13.086 1H13v4.5A1.5 1.5 0 0 1 11.5 7h-7A1.5 1.5 0 0 1 3 5.5V1H1.5a.5.5 0 0 0-.5.5m3 4a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V1H4zM3 15h10v-4.5a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5z" })
                                                        ], -1)),
                                                        _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(t)('Konfiguration speichern')), 1)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_30, [
                                                    _createElementVNode("a", {
                                                        href: (props.configuratorUrl ?? '') + '?newConfiguration=1',
                                                        target: props.configuratorUrl ? '_top' : '_self',
                                                        class: "btn btn-sm btn-light d-inline-flex align-items-center mb-3"
                                                    }, [
                                                        _cache[16] || (_cache[16] = _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "16",
                                                            height: "16",
                                                            fill: "currentColor",
                                                            class: "bi bi-plus-lg",
                                                            viewBox: "0 0 16 16"
                                                        }, [
                                                            _createElementVNode("path", {
                                                                "fill-rule": "evenodd",
                                                                d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                                            })
                                                        ], -1)),
                                                        _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(t)('Neue Konfiguration')), 1)
                                                    ], 8, _hoisted_31),
                                                    _createElementVNode("a", {
                                                        href: (props.configuratorUrl ?? '') + '?restart=1',
                                                        target: props.configuratorUrl ? '_top' : '_self',
                                                        class: "btn btn-sm btn-light d-inline-flex align-items-center mb-3"
                                                    }, [
                                                        _cache[17] || (_cache[17] = _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "16",
                                                            height: "16",
                                                            fill: "currentColor",
                                                            class: "bi bi-arrow-clockwise",
                                                            viewBox: "0 0 16 16"
                                                        }, [
                                                            _createElementVNode("path", {
                                                                "fill-rule": "evenodd",
                                                                d: "M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                                                            }),
                                                            _createElementVNode("path", { d: "M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" })
                                                        ], -1)),
                                                        _createElementVNode("span", _hoisted_34, _toDisplayString(_unref(t)('Konfiguration laden')), 1)
                                                    ], 8, _hoisted_33)
                                                ])
                                            ]),
                                            (_unref(user) && !_unref(user).isCustomer)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(props.sessionId), 1))
                                                : _createCommentVNode("", true)
                                        ])
                                    ])
                                ], 2),
                                _createElementVNode("div", {
                                    class: _normalizeClass(["col-12 h-100", { 'col-lg-9 col-xxl-10': openedNav.value }])
                                }, [
                                    _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["tab-pane fade", { 'show active': !isConfigurationLoaded.value && !hasBottlePreselection.value }]),
                                                id: "pills-1",
                                                role: "tabpanel",
                                                "aria-labelledby": "pills-1-option",
                                                tabindex: "0"
                                            }, [
                                                _createVNode(BottleSelection, {
                                                    configurationId: __props.configurationId,
                                                    tenantId: __props.tenantId,
                                                    showFilters: props.showFilters,
                                                    publicFilters: props.publicFilters,
                                                    onUpdate: updateBottleSelection
                                                }, null, 8, ["configurationId", "tenantId", "showFilters", "publicFilters"])
                                            ], 2),
                                            (selectedBottle.value)
                                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(selectedBottle.value.printAreas, (printArea, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        class: _normalizeClass(["tab-pane fade h-100 position-relative", { 'show active': !isConfigurationLoaded.value && hasBottlePreselection.value }]),
                                                        id: 'pills-3-' + index,
                                                        role: "tabpanel",
                                                        tabindex: "0"
                                                    }, [
                                                        (_openBlock(), _createBlock(BottleConfiguration, {
                                                            configurationId: __props.configurationId,
                                                            tenantId: __props.tenantId,
                                                            bottle: selectedBottle.value,
                                                            printAreaId: printArea.id,
                                                            key: configurationKey.value,
                                                            onUpdate: updateBottleConfiguration,
                                                            onBlockFurtherConfiguration: ($event) => (blockFurtherConfiguration(printArea.id, $event))
                                                        }, null, 8, ["configurationId", "tenantId", "bottle", "printAreaId", "onBlockFurtherConfiguration"]))
                                                    ], 10, _hoisted_38));
                                                }), 256))
                                                : _createCommentVNode("", true),
                                            (selectedBottle.value && availableLids.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                                    (lidSelectionConfigurationKey.value)
                                                        ? (_openBlock(), _createBlock(LidSelection, {
                                                            configurationId: __props.configurationId,
                                                            tenantId: __props.tenantId,
                                                            bottle: selectedBottle.value,
                                                            key: configurationKey.value,
                                                            onUpdate: updateLidSelection,
                                                            onNoAvailableLidsForSelectedBottle: _cache[8] || (_cache[8] = ($event) => (availableLids.value = false))
                                                        }, null, 8, ["configurationId", "tenantId", "bottle"]))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (selectedLid.value && selectedLidVariant.value && availableLids.value && !selectedLid.value.printNotPossible)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                                    (lidConfigurationKey.value)
                                                        ? (_openBlock(), _createBlock(LidConfiguration, {
                                                            configurationId: __props.configurationId,
                                                            tenantId: __props.tenantId,
                                                            lid: selectedLid.value,
                                                            key: lidConfigurationKey.value,
                                                            onUpdate: updateLidConfiguration,
                                                            onBlockFurtherConfiguration: _cache[9] || (_cache[9] = ($event) => (blockFurtherConfiguration(selectedLid.value.id, $event)))
                                                        }, null, 8, ["configurationId", "tenantId", "lid"]))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (selectedBottle.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                    (packageConfigurationKey.value)
                                                        ? (_openBlock(), _createBlock(PackageSelection, {
                                                            configurationId: __props.configurationId,
                                                            tenantId: __props.tenantId,
                                                            bottle: selectedBottle.value,
                                                            key: packageConfigurationKey.value,
                                                            onUpdate: updatePackageSelection
                                                        }, null, 8, ["configurationId", "tenantId", "bottle"]))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("div", _hoisted_42, [
                                                (selectedBottle.value != null && aiPreviewConfigurationKey.value && aiPreviewConfigurationKey.value != '')
                                                    ? (_openBlock(), _createBlock(AiPreview, {
                                                        configurationId: __props.configurationId,
                                                        tenantId: __props.tenantId,
                                                        lid: selectedLid.value,
                                                        bottle: selectedBottle.value,
                                                        key: aiPreviewConfigurationKey.value
                                                    }, null, 8, ["configurationId", "tenantId", "lid", "bottle"]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["tab-pane fade h-100 position-relative", { 'show active': isConfigurationLoaded.value }]),
                                                id: "pills-7",
                                                role: "tabpanel",
                                                "aria-labelledby": "pills-7-option",
                                                tabindex: "0"
                                            }, [
                                                (previewConfigurationKey.value && previewConfigurationKey.value != '')
                                                    ? (_openBlock(), _createBlock(Overview, {
                                                        configurationId: __props.configurationId,
                                                        tenantId: __props.tenantId,
                                                        lid: selectedLid.value,
                                                        bottle: selectedBottle.value,
                                                        package: selectedPackage.value,
                                                        productsAmount: productsAmount.value,
                                                        hasOrder: props.hasOrder,
                                                        hasBlockedConfigurationSteps: Object.keys(blockedConfigurationSteps.value).length > 0,
                                                        key: previewConfigurationKey.value
                                                    }, null, 8, ["configurationId", "tenantId", "lid", "bottle", "package", "productsAmount", "hasOrder", "hasBlockedConfigurationSteps"]))
                                                    : _createCommentVNode("", true)
                                            ], 2)
                                        ])
                                    ])
                                ], 2)
                            ])
                        ])
                    ]),
                    _: 1
                }),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    (props.externalConfigurationId)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                                _createElementVNode("div", _hoisted_45, [
                                    _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("h3", _hoisted_47, _toDisplayString(_unref(t)('Ihre Konfiguration wurde für Sie gespeichert!')), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_48, [
                                        _createElementVNode("p", null, _toDisplayString(_unref(t)('Die Konfiguration kann bis zu 12 Monate mit der folgenden ID oder über den Link wieder aufgerufen werden.')), 1),
                                        _createElementVNode("h3", _hoisted_49, _toDisplayString(props.externalConfigurationId), 1),
                                        _cache[18] || (_cache[18] = _createElementVNode("hr", null, null, -1)),
                                        (props.configurationUrl)
                                            ? (_openBlock(), _createElementBlock("a", {
                                                key: 0,
                                                href: props.configurationUrl,
                                                target: "_top"
                                            }, _toDisplayString(props.configurationUrl), 9, _hoisted_50))
                                            : _createCommentVNode("", true)
                                    ])
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ]))
            ], 64));
        };
    }
});
